var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBritishPound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 14A6 6 0 108 2a6 6 0 000 12zm-2.46-2.5h5.111l-.005-.972H7.274c.057-.072.106-.15.145-.234.117-.248.174-.527.17-.84l-.032-.884H9.06v-.952H7.522l-.044-1.191c0-.254.04-.467.122-.64a.898.898 0 01.332-.39.897.897 0 01.478-.132c.173 0 .332.032.479.097.15.065.27.171.361.318.091.143.137.337.137.58h1.181c0-.39-.083-.732-.249-1.025a1.728 1.728 0 00-.722-.693c-.316-.166-.7-.249-1.153-.249a2.44 2.44 0 00-1.132.254c-.33.17-.588.413-.777.732-.185.316-.278.699-.278 1.148l.04 1.191H5.52v.952h.808l.031.928c0 .134-.011.277-.034.43-.02.15-.058.281-.117.395a.363.363 0 01-.244.205h-.425v.972z",
    fill: "#F8DB85"
  })));
}
SvgBritishPound.displayName = 'BritishPound';
export default SvgBritishPound;